module.exports = __webpack_public_path__ + "static/img_0903-cc43eedd2864dce0f026ba602eab2505.webp";